export enum SubscriptionStatus {
  UNDEFINED = "UNDEFINED",
  NOT_ACTIVE = "NOT_ACTIVE",
  ACTIVATING = "ACTIVATING",
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
  ARCHIVED = "ARCHIVED",
  NO_PROFILE = "NO_PROFILE",
  DEACTIVATING = 'DEACTIVATING'
}
